exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".Businesses-component{height:100vh}.Businesses-component .content{width:95%;margin:auto}.Businesses-component .content .business-item{margin-top:15px;width:100%;height:60px;border:1px solid #ccc;background:#fff}.Businesses-component .content .business-item .left{float:left;width:60px;padding:5px}.Businesses-component .content .business-item .left img{border-radius:30px;width:45px;height:45px}.Businesses-component .content .business-item .right{float:right;padding-top:5px;width:calc(100% - 60px)}.Businesses-component .content .business-item .right .desc{color:#925757;font-size:12px;max-height:20px;overflow:hidden}.Businesses-component .content .footer{height:60px;background:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader?outputStyle=expanded!./src/styles/Businesses.scss
// module id = 629
// module chunks = 0